import { Component, Injector, Input, OnInit } from "@angular/core";
import { ControlValueAccessorComponent } from "ng/src/app/shared/control-value-accessor.component";
import { LogUserGroup } from "ng/src/app/users/shared/user.model";
import { UserService } from "ng/src/app/users/shared/user.service";
import { Observable } from "rxjs";
import { share, takeUntil } from "rxjs/operators";

@Component({
	selector: 'lb-user-group-list-selector[logId]',
	template: `
		<ng-container *ngVar="logGroups$ | async as groups">
			<p-listbox [options]="groups" [(ngModel)]="value" [multiple]="true" [checkbox]="true" [showToggleAll]="true" dataKey="id">
				<ng-template pTemplate="item" let-group>
					<div>
						<span>{{group.name}}</span>
					</div>
				</ng-template>
			</p-listbox>
		</ng-container>
	`,
	styleUrls: ['./log-user-group-list-selector.component.scss'],
	providers: [ControlValueAccessorComponent.getValueAccessorProvider(LogUserGroupListSelectorComponent)]
})
export class LogUserGroupListSelectorComponent extends ControlValueAccessorComponent<LogUserGroup> implements OnInit {
	
	@Input()
	set logId(val: number) {
		this._logId = val;
		this.refreshGroups();
	}
	
	get logId() {
		return this._logId;
	}
	
	constructor(
		private userService: UserService,
		injector: Injector
	) {
		super(injector);
	}
	
	private hadInit = false;
	private _logId!: number;
	
	logGroups$?: Observable<LogUserGroup[]>
	
	ngOnInit(): void {
		this.hadInit = true;
		this.refreshGroups();
	}
	
	refreshGroups() {
		if (!this.hadInit) return;
		return this.logGroups$ = this.userService.fetchLogUserGroups({
			log: this.logId,
			sort: ['name,asc']
		})
			.pipe(
				takeUntil(this.onDestroy$),
				share()
			);
	}
}